import moment from 'moment';
import { mostrarMoneda, idToTexto } from '@/utils/utils.js';

export default {
  getPedidosListadoHistorial(state) {
    //para ee llistado de pediidos dee histsorial
    var res = [];
    if (Array.isArray(state.pedidosHistorial)) {
      state.pedidosHistorial.forEach((pedR) => {
        //const aux = JSON.parse(JSON.stringify(pedR));
        const aux = pedR;
        let tlf =
          pedR.copyUser && pedR.copyUser.phoneNumber
            ? pedR.copyUser.phoneNumber
            : '-';
        aux.fecha = moment(aux.fechaServidor.toDate()).format('HH:mm');
        aux.restauranteMostrar = aux.multiple
          ? aux.copyDirectorio
            ? aux.copyDirectorio.nombre
            : 'Directorio sin nombre'
          : (aux.copyNegocio ? aux.copyNegocio.nombre : '') +
            ' ' +
            (aux.copyRest ? aux.copyRest.nombre : '');
        aux.precioTotal = mostrarMoneda(aux.precioTotal);
        aux.formaPago = idToTexto(aux.forma_pago);
        aux.telefono = tlf;
        aux.contadorMensaje = pedR.historial
          ? pedR.historial.reduce(
              (n, h) => n + h.mensaje.includes('Mensaje desde la web'),
              0
            )
          : 0;
        // aux.dobleVerificacion = pedR.historial ? (pedR.historial.reduce((n, h) => n + (h.mensaje.includes('confirmado segunda verificación')), 0)) > 0 : false
        if (!!pedR.printNodeEstado) {
          switch (pedR.printNodeEstado) {
            case 'enviadoImprimir':
              aux.colorPrinter = 'orange';
              break;
            case 'imprimido':
              aux.colorPrinter = 'green';
              break;
            default:
              aux.colorPrinter = 'red';
              break;
          }
        } else if (!!pedR.impresionLocalEstado) {
          switch (pedR.impresionLocalEstado) {
            case 'impreso':
              aux.colorPrinter = 'green';
              break;

            default:
              aux.colorPrinter = 'red';
              break;
          }
        }
        switch (
          pedR.estadoReparto //no-gestionado, creado, asignado, recogido, entregado, problema
        ) {
          case 'no-gestionado':
            aux.repartoColor = 'orange';
            aux.repartoTexto = 'Sin gestionarse';
            break;
          case 'creado':
            aux.repartoColor = 'yellow';
            aux.repartoTexto = 'Creado la petición de reparto';
            break;
          case 'asignado':
            aux.repartoColor = 'pink';
            aux.repartoTexto = 'Asignado a repartidor';
            break;
          case 'en-camino':
            aux.repartoColor = 'blue';
            aux.repartoTexto = 'En reparto';
            break;
          case 'entregado':
            aux.repartoColor = 'green';
            aux.repartoTexto = 'Entregado';
            break;
          case 'problema':
            aux.repartoColor = 'red';
            aux.repartoTexto = 'Problema en el reparto';
            break;
          default:
            aux.repartoColor = 'red';
            aux.repartoTexto = 'Sin más info';
            break;
        }
        if (aux.multiple) {
          let found = state.pedidosHistorial.find((p) => p.multiple == aux.id);
          if (Array.isArray(aux.hijos)) {
            aux.hijos.push(found);
          } else {
            aux.hijos = [];
          }
        }
        res.push(aux);
      });
      //acoplamos pedidos multiple
      return res.map((multi) => {
        if (multi.multipleHijos && multi.multipleHijos.length > 0) {
          return {
            ...multi,
            multipleHijosObj: multi.multipleHijos.map((hijo) => {
              let found = res.find((p) => p.id == hijo);
              return found ? found : {};
            }),
          };
        } else {
          return multi;
        }
      });
    } else {
      return [];
    }
  },
};
